module.exports = "/_next/static/images/futuresImage-2x-f15a5183a87e6535ab2a71c6b2c7dcae.jpg.webp";